import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { getAllCities } from '../data/cities';

export const CitiesSection = () => {
  const cities = getAllCities();

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Corporate Finance & Capital Solutions <span className="text-emerald-600">Across India</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Explore business financing, structured credit, machinery finance, property loans and capital advisory solutions across India's major commercial centres.
          </p>
        </div>

        {/* Cities Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {cities.map((city) => (
            <Link
              key={city.slug}
              to={`/locations/${city.slug}`}
              className="group relative p-8 bg-white rounded-2xl border border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              {/* Subtle gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="relative">
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-emerald-50 flex items-center justify-center mb-4 group-hover:bg-emerald-100 transition-colors">
                  <MapPin className="w-7 h-7 text-emerald-600 group-hover:scale-110 transition-transform" />
                </div>

                {/* City Name */}
                <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-emerald-700 transition-colors">
                  {city.name}
                </h3>

                {/* State */}
                <p className="text-sm text-slate-500 mb-3">{city.state}</p>

                {/* Business Theme */}
                <p className="text-sm text-slate-600 mb-4 line-clamp-2">
                  {city.businessThemes}
                </p>

                {/* Explore Link */}
                <div className="flex items-center gap-2 text-sm font-semibold text-emerald-700 group-hover:gap-3 transition-all">
                  <span>Explore Financing</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
